function getQueryStringParameter(name) {
	var urlParams = new URLSearchParams(window.location.search);

	return urlParams.get(name);
}
function searchFilter() {
	setTimeout(function () {
		var ajax_param = getQueryStringParameter('s');
		var siteURL = window.location.href;
		if (ajax_param == '1') {
			window.location.href = siteURL.replace('s=1', '');
		}
	}, 200);
}

let conditionExecuted = false;
function removeQueryParam(e) {
	let t = new URL(window.location.href);
	return t.searchParams.delete(e), t.toString();
}

let popcount = 0;
window.onpopstate = function (e) {
	if (popcount > 0) {
		return;
	}
	popcount = 1;
	let originalUrl = localStorage.getItem('original_url');

	if (!originalUrl) {
		return;
	}

	if (originalUrl.length == 0) {
		return;
	} else {
		history.back();
	}
};

// Ensure header is reset to a visible state on initial load and after Swup transitions.
(function () {
	const headerSelector = '.hd-Header';
	const hiddenModifier = 'hd-Header--hidden';

	function resetHeaderVisibility() {
		const header = document.querySelector(headerSelector);
		const { body } = document;

		if (!header || !body) {
			return;
		}

		header.classList.remove(hiddenModifier);
		body.classList.remove('is-header-hidden');
		body.classList.add('is-header-visible');
	}

	const onReady = () => resetHeaderVisibility();

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', onReady);
	} else {
		onReady();
	}

	document.addEventListener('content:replaced', resetHeaderVisibility);
	window.addEventListener('pageshow', resetHeaderVisibility);
})();

// ======================================
// Product description Read More fallback
// ======================================

(function () {

	function initialiseReadMore() {

		const readMore = document.querySelector('[data-read-more]');
		const readLess = document.querySelector('[data-read-less]');
		const preview = document.querySelector('[data-desc-preview]');
		const full = document.querySelector('[data-desc-full]');

		if (!readMore || !readLess || !preview || !full) {
			return;
		}

		// Prevent duplicate listeners
		if (readMore.dataset.initialised) {
			return;
		}

		readMore.dataset.initialised = 'true';

		readMore.addEventListener('click', function () {
			preview.classList.remove('is-expanded');
			preview.setAttribute('aria-expanded', 'false');

			full.classList.add('is-expanded');
			full.setAttribute('aria-expanded', 'true');
		});

		readLess.addEventListener('click', function () {
			full.classList.remove('is-expanded');
			full.setAttribute('aria-expanded', 'false');

			preview.classList.add('is-expanded');
			preview.setAttribute('aria-expanded', 'true');
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initialiseReadMore);
	} else {
		initialiseReadMore();
	}

	document.addEventListener('content:replaced', initialiseReadMore);

})();

// ======================================
// Free shipping message corrector (Aug 2026)
// app.js (compiled bundle) recalculates the cart free-shipping message
// with outdated thresholds baked in at build time. The Liquid-rendered
// data attributes (data-limit / data-total / data-symbol) carry the
// correct current values, so re-assert them whenever anything rewrites
// the message. Remove once app.js is rebuilt with correct logic.
// ======================================

(function () {

	function correctShippingBars() {
		document.querySelectorAll('.progress .js-value[data-limit]').forEach(function (el) {
			var limit = parseFloat(el.dataset.limit);
			var total = parseFloat(el.dataset.total);

			if (isNaN(limit) || isNaN(total) || limit <= 0) {
				return;
			}

			var progressEl = el.closest('.progress');
			var fill = progressEl ? progressEl.querySelector('.progress__bar-fill') : null;
			var diff = limit - total;

			if (diff <= 0) {
				if (progressEl && !progressEl.classList.contains('progress--granted')) {
					progressEl.classList.add('progress--granted');
				}
				if (fill && fill.style.width !== '100%') {
					fill.style.width = '100%';
				}
			} else {
				if (progressEl && progressEl.classList.contains('progress--granted')) {
					progressEl.classList.remove('progress--granted');
				}

				var text = (el.dataset.symbol || '') + diff.toFixed(2);
				if (el.textContent.trim() !== text) {
					el.textContent = text;
				}

				if (fill) {
					var width = Math.min(100, (total / limit) * 100) + '%';
					if (fill.style.width !== width) {
						fill.style.width = width;
					}
				}
			}
		});
	}

	var observer = new MutationObserver(function () {
		correctShippingBars();
	});

	function init() {
		correctShippingBars();

		observer.observe(document.body, {
			subtree: true,
			childList: true,
			characterData: true,
			attributes: true,
			attributeFilter: ['class', 'style', 'data-total', 'data-limit']
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('cartDrawer:refreshed', correctShippingBars);
	document.addEventListener('content:replaced', correctShippingBars);
})();
